import React from 'react';
import styles from './DownloadModal.module.css';

const PDF_OPTIONS = invoice => [
  { label: '📄 Download Admin Invoice', url: invoice.adminPlacePdfUrl },
  { label: '📄 Download Restaurant Invoice', url: invoice.placePdfUrl },
];

const CSV_OPTIONS = invoice => [
  { label: '📊 Download Admin Invoice', url: invoice.adminPlaceCsvUrl },
  { label: '📊 Download Restaurant Invoice', url: invoice.placeCsvUrl },
];

const DownloadModal = ({ type, invoice, onClose }) => {
  if (!type || !invoice) return null;

  const options = type === 'pdf' ? PDF_OPTIONS(invoice) : CSV_OPTIONS(invoice);
  const title = type === 'pdf' ? 'PDF Invoice' : 'CSV Invoice';

  return (
    <div
      className={styles.bg}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.box}>
        <div className={styles.header}>
          <div className={styles.title}>Download {title}</div>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.options}>
          {options.map(({ label, url }) => (
            <div key={label} className={styles.optionRow}>
              <button
                className={styles.optionBtn}
                disabled={!url}
                style={{ opacity: url ? 1 : 0.4, cursor: url ? 'pointer' : 'not-allowed' }}
                onClick={() => {
                  window.open(url, '_blank');
                  onClose();
                }}
              >
                {label}
              </button>
              {!url && (
                <span className={styles.optionError}>
                  Not available for this invoice
                </span>
              )}
            </div>
          ))}
        </div>

        <button className={styles.cancelBtn} onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DownloadModal;
